import { QueuedIntakeFileInfo, UploadData } from '../../../store/uploadStore';
import { calcHash } from '../../../libs/file';
import { UploadNotRestoredError } from '../../../errors/UploadNotRestoredError';
import { UploadPhoto } from '../../../types';

const queueToUploadFile = (
  { name, fileCategory, size, cameraModel, takenAt, datePrecise, validation, coords }: QueuedIntakeFileInfo,
  hash: string,
): UploadPhoto => {
  return {
    uploaded: true,
    fileCategory,
    size,
    cameraModel,
    takenAt,
    datePrecise,
    name,
    validation,
    hash,
    coords,
  };
};

const removeRegisteredPhoto = (upload: UploadData, hash) => {
  if (!upload.upload) throw new UploadNotRestoredError();

  const registeredPhotoIndex = upload.upload.photos.findIndex((p) => p.hash === hash);
  if (registeredPhotoIndex !== -1) {
    upload.upload.photos.splice(registeredPhotoIndex, 1);
  }
};

export const moveFileFromQueueToUpload = (upload: UploadData, file: QueuedIntakeFileInfo) => {
  if (!upload.upload) throw new UploadNotRestoredError();

  const index = upload.queue.indexOf(file);
  if (index !== -1) {
    const hash = calcHash(file.file);

    upload.queue.splice(index, 1);
    upload.overview.photosCount.uploaded++;

    // For interrupted uploads this photo might already be registered
    removeRegisteredPhoto(upload, hash);

    upload.upload.photos.push(queueToUploadFile(file, hash));
  }
};
